@if (isPrinting()) {
  <div class="print-container">
    <ng-content></ng-content>
    <ng-container *ngTemplateOutlet="windowPrinterService.printingTemplate()" />
  </div>
}
